import { IntegrationsStore } from '@/core/store/Integrations'

export const useFraudDefenseStatus = () => {
    const hasBrokenIntegrationWithEnabledFdService =
        IntegrationsStore.hasBrokenIntegrationWithEnabledFdService()
    const hasDisabledFdServices =
        IntegrationsStore.getNumberOfDisabledFDSecurityServices() > 0
    const hasEnabledFdServices =
        IntegrationsStore.getNumberOfFdEnabledSecurityServices() > 0

    const getFdStatus = () => {
        if (hasBrokenIntegrationWithEnabledFdService) {
            return {
                title: 'Lost connection detected',
                description:
                    'Some of your emails are not protected. Please reconnect the disconnected  accounts.',
            }
        }
        if (hasDisabledFdServices) {
            if (hasEnabledFdServices) {
                return {
                    title: 'At least one of the Fraud Defense services is disabled',
                    description:
                        "Your disabled accounts aren't being monitored and may be exposed to threats. To enable Fraud Defense, please enable your accounts.",
                }
            }
            return {
                title: 'Fraud Defense is disabled',
                description:
                    "Your accounts aren't being monitored and may be exposed to threats. To enable Fraud Defense, please enable your accounts.",
            }
        }
        return null
    }

    return {
        fdStatusData: getFdStatus(),
    }
}
